import type { AppRouter } from "@ocr-monorepo/admin-api/router";
import { createTRPCContext } from "@trpc/tanstack-react-query";
export const { TRPCProvider, useTRPC } = createTRPCContext<AppRouter>();
